module.exports = __webpack_public_path__ + "img/zizhi7.eb8011da.jpg";